/**
 * Delegate "my workspaces" API — Feature 075 (plan 013, Workstream B).
 * Bootstrap call for the workspace banner/switcher; made BEFORE any
 * `x-workspace-owner-id` header exists (the backend endpoint deliberately
 * skips WorkspaceGuard).
 */

import { apiClient } from '@/core/api/client';
import type { UserRole } from '@/core/auth/types';
import type { DelegationPermission } from '@/shared/components/sub-delegation';

export type MyWorkspace = {
  relationshipId: string;
  ownerId: string;
  ownerFirstName: string;
  ownerLastName: string | null;
  ownerRole: UserRole;
  permissions: DelegationPermission[];
  createdAt: string;
};

export async function listMyWorkspaces(): Promise<MyWorkspace[]> {
  const response = await apiClient.get<MyWorkspace[]>('/workspace/my-workspaces');
  return response.data;
}

export const myWorkspacesApi = { listMyWorkspaces };
